import { connect } from "react-redux";
import Verify from "./";
import { Effects } from "@/store/shared/effects";

const mDp = {
  verifyPhone: Effects.acceptInviteByPhone,
};

export default connect(null, mDp)(Verify);
